// Google Maps JS API loader + distance / geocode helpers.
let loadPromise = null;

export function loadGoogle() {
  if (typeof window !== "undefined" && window.google && window.google.maps) {
    return Promise.resolve(window.google);
  }
  if (loadPromise) return loadPromise;
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  loadPromise = new Promise((resolve, reject) => {
    if (!key) { reject(new Error("Missing Google Maps API key")); return; }
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=de&region=CH`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(window.google);
    s.onerror = () => reject(new Error("Failed to load Google Maps"));
    document.head.appendChild(s);
  });
  return loadPromise;
}

// Zürich Airport (ZRH) coordinates
export const ZRH = { lat: 47.4581, lng: 8.5555 };

export const COUNTRIES = ["ch", "de", "fr", "it", "at", "li"];

export async function distanceFromAirport(dest) {
  const g = await loadGoogle();
  return new Promise((resolve) => {
    const svc = new g.maps.DistanceMatrixService();
    svc.getDistanceMatrix(
      { origins: [ZRH], destinations: [dest], travelMode: g.maps.TravelMode.DRIVING },
      (resp, status) => {
        try {
          if (status === "OK" && resp.rows[0].elements[0].status === "OK") {
            const el = resp.rows[0].elements[0];
            resolve({ km: Math.round(el.distance.value / 1000), min: Math.round(el.duration.value / 60) });
          } else {
            resolve(null);
          }
        } catch (e) { resolve(null); }
      }
    );
  });
}

// Total driving distance for a route with optional intermediate waypoints.
// points: array of {lat,lng} in order (origin, ...stops, destination).
export async function routeDistance(points) {
  const pts = (points || []).filter(Boolean);
  if (pts.length < 2) return null;
  const g = await loadGoogle();
  const origin = pts[0];
  const destination = pts[pts.length - 1];
  const waypoints = pts.slice(1, -1).map((p) => ({ location: p, stopover: true }));
  return new Promise((resolve) => {
    const svc = new g.maps.DirectionsService();
    svc.route(
      { origin, destination, waypoints, travelMode: g.maps.TravelMode.DRIVING },
      (resp, status) => {
        try {
          if (status === "OK" && resp.routes[0]) {
            let meters = 0, secs = 0;
            resp.routes[0].legs.forEach((l) => { meters += l.distance.value; secs += l.duration.value; });
            resolve({ km: Math.round(meters / 1000), min: Math.round(secs / 60) });
          } else { resolve(null); }
        } catch (e) { resolve(null); }
      }
    );
  });
}

export async function geocode(address) {
  const g = await loadGoogle();
  return new Promise((resolve) => {
    const gc = new g.maps.Geocoder();
    gc.geocode({ address, region: "CH" }, (res, status) => {
      if (status === "OK" && res && res[0]) {
        resolve({
          label: res[0].formatted_address,
          lat: res[0].geometry.location.lat(),
          lng: res[0].geometry.location.lng(),
        });
      } else {
        resolve(null);
      }
    });
  });
}
